import { createGlobalStyle } from 'styled-components';

const baseStyles = createGlobalStyle`
  button:focus {
    outline: none !important;
  }

  /* Hide global inline help widget from Inmanual */
  .inmplayer-trigger {
    display: none !important;
  }

  /* Hide global Feedback button */
  .rc-feedbackbutton-iframe {
    display: none;
  }
`;

export default baseStyles;
